import { type QuickStepHotkeyId } from "owa-quick-step-types";
import { hotkeyEight as Strings_hotkeyEight, hotkeyFive as Strings_hotkeyFive, hotkeyFour as Strings_hotkeyFour, hotkeyNine as Strings_hotkeyNine, hotkeyOne as Strings_hotkeyOne, hotkeySeven as Strings_hotkeySeven, hotkeySix as Strings_hotkeySix, hotkeyThree as Strings_hotkeyThree, hotkeyTwo as Strings_hotkeyTwo, } from "./getHotkeyDropdownOptions.locstring.json";
import loc, { type LocalizedString } from "owa-localize";

export function getQuickStepHotkeyText(hotkey: QuickStepHotkeyId | undefined): LocalizedString | undefined {
    switch (hotkey) {
        case 6:
            return loc(Strings_hotkeyOne);
        case 7:
            return loc(Strings_hotkeyTwo);
        case 8:
            return loc(Strings_hotkeyThree);
        case 9:
            return loc(Strings_hotkeyFour);
        case 0:
            return loc(Strings_hotkeyFive);
        case 1:
            return loc(Strings_hotkeySix);
        case 2:
            return loc(Strings_hotkeySeven);
        case 3:
            return loc(Strings_hotkeyEight);
        case 4:
            return loc(Strings_hotkeyNine);
        default:
            return undefined;
    }
}
